import React from "react";

import CheckIcon from "@mui/icons-material/Check";
import { Box, Drawer, Stack } from "@mui/material";
import { CrunchbaseIcon } from "assets/material-custom-icons";
import { SimpleHeadMui } from "components/Simple-head/SimpleHeadMui";
import { useCrunchbaseDrawerSelect, useDealCrunchbaseIdSelect, useViewActions } from "store";

import { Main } from "./Main";

export const Crunchbase: React.FC = () => {
  const { setCrunchbaseStateAction } = useViewActions();

  const crunchbaseId = useDealCrunchbaseIdSelect();
  const isDrawerOpen = useCrunchbaseDrawerSelect();

  const onClose = () => {
    setCrunchbaseStateAction(false);
  };

  return (
    <>
      <Box sx={{ position: "relative" }} onClick={() => setCrunchbaseStateAction(true)}>
        {crunchbaseId && (
          <CheckIcon
            sx={{
              position: "absolute",
              bgcolor: "#5DCBB7",
              borderRadius: "50%",
              color: "white",
              fontSize: "18px",
              border: "1px solid white",
              top: "-7px",
              right: "-10px",
              cursor: "pointer"
            }}
          />
        )}
        <CrunchbaseIcon sx={{ height: "30px", width: "30px", cursor: "pointer" }} />
      </Box>
      <Drawer
        sx={{
          ".MuiPaper-root": {
            borderTopRightRadius: "25px",
            borderBottomRightRadius: "25px"
          }
        }}
        open={isDrawerOpen}
        onClose={onClose}
      >
        <Stack alignItems="stretch" height="100%" maxWidth="506px" minWidth="506px" bgcolor="#ffffff" overflow="hidden">
          <SimpleHeadMui onIconClick={onClose}>Crunchbase Connection</SimpleHeadMui>
          <Main crunchbaseId={crunchbaseId} onClose={onClose} />
        </Stack>
      </Drawer>
    </>
  );
};
